// A user's service_desk_id binding: a single id, an array, or the "*" wildcard.
export type DeskIdRaw = number | string | (number | string)[] | null | undefined;

// Does a binding cover a specific desk (honouring the "*" wildcard)?
export const deskListCovers = (raw: DeskIdRaw, deskId: number): boolean => {
  const list = Array.isArray(raw) ? raw : raw != null ? [raw] : [];
  return list.some((v) => v === '*' || Number(v) === deskId);
};

// Parse a binding into { all: has "*", ids: numeric desk ids }.
export const parseDeskAccess = (raw: DeskIdRaw): { all: boolean; ids: Set<number> } => {
  const list = Array.isArray(raw) ? raw : raw != null ? [raw] : [];
  return {
    all: list.includes('*'),
    ids: new Set(list.map(Number).filter((n) => Number.isFinite(n) && n > 0)),
  };
};
